<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        @if (!condtag) {
            <li class="dl-nodemenu__item" data-uitleg="quantity" [class.selectedMenuItem]="isActiefInitAddActie('quantity')" (click)="uitvoerInitAddAction({type:'quantity'})" title="{{ 'ADD_QUANTITY' | translate }}">
                <a class="quantity"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="configuration" [class.selectedMenuItem]="isActiefInitAddActie('configuration')" (click)="uitvoerInitAddAction({type:'configuration'})" title="{{ 'ADD_CONFIGURATION' | translate }}">
                <a class="connected_entities"></a>
            </li>
            @if (effectiefModelleerniveau >= 40) {
                <li class="dl-nodemenu__item" data-uitleg="attribute" [class.selectedMenuItem]="isActiefInitAddActie('attribute')" (click)="uitvoerInitAddAction({type:'attribute'})" title="{{ 'ADD_ATTRIBUTE' | translate }}">
                    <a class="attribute"></a>
                </li>
            }
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
</div>
